/**
 * The style position attributes
 * @type {String[]}
 */
const STYLE_POSITION_ATTRIBUTES = ['top', 'left', 'height', 'width'];

export { STYLE_POSITION_ATTRIBUTES };
